import React, { ReactNode } from 'react';
import { AuthProvider, useAuthState } from './authcontext'
import { ResourceProvider } from './appcontext'

type PropsChildren = {children?: ReactNode}

const ApplicationProvider: React.FC<PropsChildren> = props => {
    return (
        <AuthProvider>
            <AppProvider>
                {props.children}
            </AppProvider>
        </AuthProvider>
    )
}


const AppProvider = (props: PropsChildren) => {
    var { userData } = useAuthState()
    return (
            <ResourceProvider authUser={userData ? userData : {}} > 
                {props.children}
            </ResourceProvider>
            
    )
}


// const SelectionProvider = props => {

//     let { userneed } = useAuthState()
//     let is_kitchen_owner = userneed === "chef"
//     console.log("SelectionProvider is_kitchen_owner", is_kitchen_owner)
//     if (is_kitchen_owner){
//         return ( <KitchenProvider> {props.children} </KitchenProvider>)
//     } else {
//         return (<MemberProvider> {props.children} </MemberProvider>)
//     }
// }

export default ApplicationProvider
